import type { ButtonHTMLAttributes } from 'react'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement>

export function PrimaryButton({ className = '', ...rest }: ButtonProps): JSX.Element {
  return <button type="button" className={`btn-primary ${className}`.trim()} {...rest} />
}

export function SecondaryButton({ className = '', ...rest }: ButtonProps): JSX.Element {
  return <button type="button" className={`btn-secondary ${className}`.trim()} {...rest} />
}

export function LinkButton({ className = '', ...rest }: ButtonProps): JSX.Element {
  return <button type="button" className={`link-button ${className}`.trim()} {...rest} />
}
